var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import DataBox from '~/components/common/data-box.vue';
import DataForm from '~/components/common/data-form.vue';
import NumberRange from '~/components/common/number-range.vue';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { State } from "vuex-class";
import { CarManageService } from '~/services/domain-service/car-manage.service';
import SelectDepartment from "~/components/business-component/select-department.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
var WarehousingVehicleReport = /** @class */ (function (_super) {
    __extends(WarehousingVehicleReport, _super);
    function WarehousingVehicleReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            batchNumber: "",
            caseNumber: '',
            principalId: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            loanDate: [],
            inWarehouseTime: [],
            applyRealName: '',
            warehouseCarStatus: '',
            garageId: '',
            deptId: '',
            approvalRealName: ''
        };
        _this.dataSet = [];
        _this.garageList = [];
        return _this;
    }
    WarehousingVehicleReport.prototype.refreshData = function () {
        var _this = this;
        this.carManageService.getWarehouseCarReport(this.paramsHandler(), this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    WarehousingVehicleReport.prototype.onClickExport = function () {
        var _this = this;
        if (!this.dataSet.length)
            return this.$message.warning('暂无数据无需导出！');
        this.carManageService.warehouseCarReportExport(this.paramsHandler()).subscribe(function (data) {
            _this.$common.downloadFile(data.url);
        });
    };
    WarehousingVehicleReport.prototype.paramsHandler = function () {
        var params = __assign({}, this.dataForm);
        params.loanDateMin = this.$filter.dateRanageFormat(this.dataForm.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.dataForm.loanDate).end;
        params.inWarehouseTimeMin = this.dataForm.inWarehouseTime.length ? this.$filter.dateTimeFormat(this.dataForm.inWarehouseTime[0]) : '';
        params.inWarehouseTimeMax = this.dataForm.inWarehouseTime.length ? this.$filter.dateTimeFormat(this.dataForm.inWarehouseTime[1]) : '';
        delete params.applyTime;
        delete params.loanDate;
        return params;
    };
    WarehousingVehicleReport.prototype.departemntChange = function (id, code) { };
    WarehousingVehicleReport.prototype.getGarageList = function () {
        var _this = this;
        this.carManageService.getAllGaragesList().subscribe(function (data) {
            _this.garageList = data;
        });
    };
    WarehousingVehicleReport.prototype.created = function () {
        this.refreshData();
        this.getGarageList();
    };
    /**
     * 进入查看执行页
     */
    WarehousingVehicleReport.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Warehousing_vehicle_report,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(PageService)
    ], WarehousingVehicleReport.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], WarehousingVehicleReport.prototype, "carManageService", void 0);
    __decorate([
        State
    ], WarehousingVehicleReport.prototype, "principalList", void 0);
    WarehousingVehicleReport = __decorate([
        Auth(2103),
        Layout('workspace'),
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                NumberRange: NumberRange,
                SelectDepartment: SelectDepartment
            }
        })
    ], WarehousingVehicleReport);
    return WarehousingVehicleReport;
}(Vue));
export default WarehousingVehicleReport;
